import { ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { map, switchMap, take } from 'rxjs/operators';

import {
  EntityConnectionTypeDetailsFragment, GetEntityConnectionTypesGQL, GetEntityPublicGQL,
  GetEntityPublicQuery, GetTagsByIdsForQueryGQL, SearchActivityEvents
} from 'generated/graphql';

import { selectCampaignId } from 'app/_state/router/router-selectors';
import {
  MassRemoveEntityConnectionOperationData
} from 'app/quick-apply/types/mass-operation-types';
import { WithDisposableSubject } from 'core/mixins/with-disposable-subject';

import { MassOperationActivityEventPayload } from '../types';

@Component({
  selector: 'app-mass-remove-connection-event',
  templateUrl: './mass-remove-connection-event.component.html'
})
export class ASMassRemoveConnectionEventComponent extends
  WithDisposableSubject() implements OnInit {
  @Input() item: SearchActivityEvents.Node;

  get payload(): MassOperationActivityEventPayload<MassRemoveEntityConnectionOperationData> {
    return this.item?.payload;
  }

  entityConnectionType: EntityConnectionTypeDetailsFragment;
  entity: GetEntityPublicQuery['getEntityPublic'];

  /**
   *
   */
  constructor(
    private _getTagService: GetTagsByIdsForQueryGQL,
    private _getEntityPublic: GetEntityPublicGQL,
    private _getEntityConnectionTypes: GetEntityConnectionTypesGQL,
    private _store: Store,
    private _cd: ChangeDetectorRef
  ) {
    super();
  }

  ngOnInit() {
    const opData = this.payload.operationData;

    this._store.select(
      selectCampaignId
    ).pipe(
      take(1),
      switchMap((campaignId: string) => this._getEntityPublic.fetch(
        {
          campaignId,
          entityId: opData.toEntityId
        }
      ).pipe(
        map(({ data }) => data.getEntityPublic),
        switchMap((entity) => this._getEntityConnectionTypes.fetch().pipe(
          map(({ data }) => {
            const entityConnectionType = data
              .getEntityConnectionTypes.find(d => d.id === opData.entityConnectionTypeId);
            return {
              entity, entityConnectionType
            };
          })
        ))
      )
      ),
    )
      .subscribe(
        (vm) => {
          this.entity = vm.entity;
          this.entityConnectionType = vm.entityConnectionType;
          this._cd.markForCheck();
        }
      );
  }

}


